import { useSearchParams } from "react-router-dom";
import { useCallback } from "react";

export default function useWithUrlTenant() {
  const [searchParams] = useSearchParams();
  const tenantId = searchParams.get("tenantId");

  const withTenant = useCallback(
    (url) => {
      if (tenantId && tenantId.trim() !== "") {
        const separator = url.includes("?") ? "&" : "?";
        return `${url}${separator}tenantId=${tenantId}`;
      }
      return url;
    },
    [tenantId]
  );

  return withTenant;
}
